import { Label } from "@/components/ui/label";

export type SoundFilterOption = { value: string; label: string };

export function SoundFilterSelect({
  id,
  label,
  value,
  options,
  allLabel = "All",
  onChange,
}: {
  id: string;
  label: string;
  value: string;
  options: SoundFilterOption[];
  allLabel?: string;
  onChange: (value: string) => void;
}) {
  return (
    <div className="space-y-1">
      <Label htmlFor={id}>{label}</Label>
      <select
        id={id}
        className="h-9 w-full rounded-md border bg-background px-3 text-sm"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      >
        <option value="all">{allLabel}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
